// Created for Responsive Breakpoints

const size = {
  mobileS: '320px',
  mobileL: '375px',
  tablet: '869px',
  laptop: '1024px',
  desktop: '1440px',
};

export const device = {
  // Generice Mobile - I.E All mobile devices up to tablet
  mobile: `(min-width: 220px) and (max-width: ${size.tablet})`,
  // Device Specific Queries below here
  mobileS: `(min-width: ${size.mobileS}) and (max-width: ${size.mobileL})`,
  mobileL: `(min-width: ${size.mobileL}) and (max-width: ${size.tablet})`,
};
